export default __webpack_public_path__ + "static/media/learn-more.e5b4f440.jpg";